// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentLinkDetails_root__3OBkl","header":"PaymentLinkDetails_header__g105C","codeDisplay":"PaymentLinkDetails_codeDisplay__7ZWU8"};